import React from 'react';
import { bindActionCreators } from 'redux';
import { Circles } from '../../common/loadingComponent';
import { connect } from 'react-redux';
import { getParams, getDobFromPin } from '../../common/utils';
import { isEqual } from 'lodash';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { MomentDate } from '../../common/momentComponent';
import { searchActions, searchStatus, cuzkSearchType } from '../../../store/searchStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import Message from '../../common/message';
import NoDataComponent from '../../common/noDataComponent';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import PropertyCzCadastreUnit from './propertyCzCadastreUnit';
import BasicRow from '../../reportSections/identData/basicRow';

import './propertyCz.scss';

class PropertyCzReportOwnersipDeed extends React.Component {
    componentDidMount() {
        if (!isNullOrUndefined(window.location.search) && window.location.search !== "") {
            const params = getParams(window.location.search);
            params.id ? this.props.cuzkGetOwnershipDeedRequest(params) : this.props.cuzkGetOwnershipDetailAsReport(params);
        }
    }

    componentDidUpdate(prevProps) {
        if (!isNullOrUndefined(window.location.search) && window.location.search !== "") {
            const params = getParams(window.location.search);
            const stateParams = this.getSearchResult("params");
            if ((!isNullOrUndefined(stateParams) && !isEqual(stateParams, params)) || this.props.location.search !== prevProps.location.search)
                params.id ? this.props.cuzkGetOwnershipDeedRequest(params) : this.props.cuzkGetOwnershipDetailAsReport(params);
        }
    }

    render() {
        if (this.getSearchResult("status") === searchStatus.requested)
            return <Circles />;

        const error = this.getSearchResult("error");

        if (!isNullOrUndefined(error)) {
            return (
                <div className="error-container error-container-wide" style={{ marginTop: "0.75em" }}>
                    <Message type={error.exceptionLevel || "error"} options={{ renderInnerHtml: true }} message={this.props.translate(error.exception || "UnhappyUser.InternalServerError", isNullOrUndefined(error.exceptionData) ? undefined : error.exceptionData)} />
                </div>
            );
        }

        const data = this.getSearchResult("data");

        if (!isNullOrUndefined(data) && !isNullOrUndefined(data.exception)) {
            return (
                <div className="error-container error-container-wide" style={{ marginTop: "0.75em" }}>
                    <Message type={data.exceptionLevel || "error"} options={{ renderInnerHtml: true }}
                        message={this.props.translate(data.exception, isNullOrUndefined(data.exceptionData) ? undefined : data.exceptionData)}
                    />
                </div>
            );
        }

        if (isNullOrUndefined(data))
            return <NoDataComponent />;

        return (
            <>
                {this.renderReportDateInformation(data)}
                <div className='card'>
                    <div className='card-body'>
                        <div className="ident-data">
                            <BasicRow title="PropertyCz.Search.CadastreUnitId" value={data.cadastreUnitName} />
                            <BasicRow title="PropertyCz.Search.OwnershipDeedNo" value={data.ownershipDeedNo} />
                            {!isNullOrUndefined(data.dataDate) &&
                                <BasicRow title="PropertyCz.Search.DataDate" value={<MomentDate value={data.dataDate} />} />}
                        </div>
                        {!isNullOrUndefined(data.cadastreUnits) && data.count !== 0 && this.renderCadastralUnitsOverview(data)}
                        {data.count === 0 && <div className="cuzk-oo-wrapper"><b><Translate id='Search.Cee.ResultCount' />: 0</b></div>}
                    </div>
                </div>
                <div className="disclaimer-wrapper">
                    <div className="report-component" style={{ textAlign: "center" }}><Translate id="Report.Footer" /></div>
                    <hr style={{ marginTop: "4px", marginBottom: "4px", height: "1px" }} />
                    <div className="disclaimer-gray"><Translate id="PropertyCz.Disclaimer" /></div>
                </div>
            </>
        )
    }

    renderReportDateInformation(data) {
        return (
            <div className="cuzk-query-date">
                <div>
                    <span className="bold"><Translate id="PropertyCz.Inserted" />: </span>
                    <span className="bold">{data.insertedFormated}</span>
                </div>
                <div>
                    <span className="bold"><Translate id="PropertyCz.Completed" />: </span>
                    <span className="bold">{data.completedFormated}</span>
                </div>
            </div>
        );
    }

    renderCadastralUnitsOverview = (data) => {
        return (
            <div className="cuzk-oo-wrapper">
                <div className="cuzk-available">
                    <div className="cuzk-column">
                    </div>
                    <span className='cuzk-column underlined-title-wrapper' style={{ margin: "1em 0" }}>
                        <span className='underlined-title'><Translate id="PropertyCz.Report.OwnershipDeedsOverview" /></span>
                    </span>
                    <div className="cuzk-column" />
                </div>
                <OldStyleTableWithHistory
                    colWidths={data.anyRestrictions ? ['', '8%', '', '8%', '20%', '8%', '20%', '8%'] : ['', '9%', '', '9%', '22%', '9%', '21%']}
                    colWidthsOnMobile={false}
                    head={() => <thead>
                        <tr>
                            <th style={{ width: '4em' }} />
                            <th><Translate id="PropertyCz.Report.CU.CadastreUnitId" /></th>
                            <th style={{ width: '7.5em' }}><Translate id="PropertyCz.Report.CU.CadastreUnitName" /></th>
                            <th><Translate id="PropertyCz.Report.CU.MunicipalityId" /></th>
                            <th><Translate id="PropertyCz.Report.CU.MunicipalityName" /></th>
                            <th><Translate id="PropertyCz.Report.CU.DistrictId" /></th>
                            <th style={{ width: '6.5em' }}><Translate id="PropertyCz.Report.CU.DistrictName" /></th>
                            {data.anyRestrictions && <th><Translate id="PropertyCz.Report.OD.Restriction" /></th>}
                        </tr>
                    </thead>}
                    actualData={data.cadastreUnits} fixed classNames='old-style-bordered'
                    actualRow={i => <PropertyCzCadastreUnit data={i}
                        key={i.cadastreUnitId} showRestrictions={data.anyRestrictions} fromSearch={true} />}
                />
            </div>
        );
    }

    getSearchResult = (field) => {
        if (isNullOrUndefined(this.props.search))
            return null;
        if (field === "error" && !isNullOrUndefined(this.props.search[cuzkSearchType.requests]))
            return this.props.search[cuzkSearchType.requests][field];
        if (!isNullOrUndefined(this.props.search[cuzkSearchType.report]))
            return this.props.search[cuzkSearchType.report][field];
        return null;
    }
}

export default withRouter(withLocalize(connect(
    state => ({ search: { ...state.search.cuzk } }),
    dispatch => bindActionCreators(searchActions, dispatch),
)(PropertyCzReportOwnersipDeed)));
